export const getRateplanData = ratePlans => {
  const fleetTrackingServices = [];
  const assetTrackingServices = [];
  const videoTelematicServices = [];
  const tattleSystemServices = [];
  let fiftyPercentInUSSelected = false;

  Object.keys(ratePlans).forEach(planName => {
    Object.keys(ratePlans[planName]).forEach(deviceName => {
      const {
        term,
        quantity,
        unitPrice,
        fiftyPercentInUS,
        rateplanType
      } = ratePlans[planName][deviceName];
      if (fiftyPercentInUS) fiftyPercentInUSSelected = true;

      if (term && quantity) {
        const dataObj = {
          name: planName,
          device: deviceName,
          term,
          quantity,
          unitPrice,
          fiftyPercentInUS
        };
        if (rateplanType === 'Fleet Tracker')
          fleetTrackingServices.push(dataObj);
        if (rateplanType === 'Asset Tracker')
          assetTrackingServices.push(dataObj);
        if (rateplanType === 'Video Telematics')
          videoTelematicServices.push(dataObj);
        if (rateplanType === 'Tattle System')
          tattleSystemServices.push(dataObj);
      }
    });
  });
  return {
    fleetTrackingServices,
    assetTrackingServices,
    videoTelematicServices,
    tattleSystemServices,
    fiftyPercentInUSSelected
  };
};

export const getHardwareData = (hardware, productSelected) => {
  const hardwareList = [];
  const accessoryList = [];
  const ravenAccessoryList = [];

  Object.keys(hardware).forEach(hardwareName => {
    const {
      includedQuantity,
      additionalQuantity,
      unitPrice,
      isAccessory,
      isRavenAccessory,
      OBDQuantity
    } = hardware[hardwareName];
    if (includedQuantity + additionalQuantity > 0)
      if (isAccessory) {
        if (productSelected === 'GeoTab' && isRavenAccessory)
          ravenAccessoryList.push({
            name: hardwareName,
            includedQuantity,
            additionalQuantity,
            unitPrice,
            OBDQuantity: OBDQuantity ? OBDQuantity : 0
          });
        else
          accessoryList.push({
            name: hardwareName,
            includedQuantity,
            additionalQuantity,
            unitPrice
          });
      } else
        hardwareList.push({
          name: hardwareName,
          includedQuantity,
          additionalQuantity,
          unitPrice
        });
  });

  return {
    hardwareList,
    accessoryList,
    ravenAccessoryList
  };
};

export const getDataOfAccessories = hardware => {
  const accessoryList = [];

  Object.keys(hardware).forEach(hardwareName => {
    const {
      includedQuantity,
      additionalQuantity,
      unitPrice,
      isAccessory
    } = hardware[hardwareName];
    if (includedQuantity + additionalQuantity > 0)
      if (isAccessory) {
        accessoryList.push({
          name: hardwareName,
          includedQuantity,
          additionalQuantity,
          unitPrice
        });
      }
  });

  return accessoryList;
};

export const getTechnicalServicesData = technicalServices =>
  Object.entries(technicalServices).reduce(
    (acc, [serviceName, serviceDataObj]) => {
      const { quantity, servicePrice } = serviceDataObj;
      if (quantity > 0)
        return [
          ...acc,
          {
            name: serviceName,
            quantity,
            price: servicePrice
          }
        ];
      return acc;
    },
    []
  );

const FARM_AND_RANCH_TANK_DETAILS_TITLE_MAPPING = {
  fuelGauge: 'TELUS Farm Fuel Mgmt – Fuel Gauge with Float Arm (Gas or Diesel)',
  fuelPressure: 'TELUS Farm Fuel Mgmt – Fuel Pressure',
  propane: 'TELUS Farm Propane Mgmt – Propane'
};

export const getFarmAndRanchTankDetails = tankDetailsFarmAndRanch =>
  Object.entries(tankDetailsFarmAndRanch).reduce((acc, [key, value]) => {
    return [
      ...acc,
      {
        key,
        title: FARM_AND_RANCH_TANK_DETAILS_TITLE_MAPPING[key],
        details: value
      }
    ];
  }, []);

const BYOD_DEVICE_NAME = 'BYOD';

const normalizeName = value =>
  typeof value === 'string' ? value.replace(/\s+/g, ' ').trim().toLowerCase() : '';

// Keep BYOD only on the rate plan(s) named in `byodPlanNames` (e.g. 'Go Core');
// strip it from every other plan. Match is case/whitespace-insensitive against
// the plan's `rateplanName`.
export const showByodOnActivation = (rateplanList = [], byodPlanNames = []) => {
  const allowedPlans = (Array.isArray(byodPlanNames)
    ? byodPlanNames
    : [byodPlanNames]
  ).map(normalizeName);

  return rateplanList.map(rateplan => {
    const deviceList = rateplan.fields.deviceList || [];
    const keepByod = allowedPlans.includes(
      normalizeName(rateplan.fields.rateplanName)
    );

    return {
      ...rateplan,
      fields: {
        ...rateplan.fields,
        deviceList: keepByod
          ? deviceList
          : deviceList.filter(
              device => device.fields.deviceName !== BYOD_DEVICE_NAME
            )
      }
    };
  });
};

